import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const FacebookRoundIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 20;
  const color = props.color || 'white';
  return <Icon name={'facebook-round'} size={size} color={color} />;
};

export default React.memo(FacebookRoundIcon);
